import React from "react";
import { Button } from "@chakra-ui/react";
import { AutoComplete, Form, Modal, TextInput } from "components";
import { SURGEON_ROLES } from "duck";
import { Clients, Patients } from "./components";
import { FormValues, getValidation, useImportVetspireCase } from "./duck";

interface IntegrateProps {
  isOpen: boolean;
  onClose(): void;
}

const Integrate: React.FC<IntegrateProps> = ({ isOpen, onClose }) => {
  const onSubmit = useImportVetspireCase();

  return (
    <>
      {isOpen && (
        <Modal title="Create case from EMR" onClose={onClose} isOpen>
          <Form<FormValues>
            {...getValidation()}
            onSubmit={onSubmit}
            display="flex"
            flexDirection="column"
            gridGap={6}
          >
            <TextInput
              name="caseName"
              label="Case Name"
              placeholder="Enter Case Name"
            />

            <AutoComplete.Users
              name="doctor"
              role={SURGEON_ROLES}
              placeholder="Select Doctor"
              label="Doctor"
            />

            <Clients />

            <Patients />

            <Form.Controls submitText="Save">
              <Button
                color="gray.700"
                variant="outline"
                colorScheme="gray"
                onClick={onClose}
              >
                Cancel
              </Button>
            </Form.Controls>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default Integrate;
